import { render, staticRenderFns } from "./service_safety.vue?vue&type=template&id=476f8b89&scoped=true&"
import script from "./service_safety.vue?vue&type=script&lang=js&"
export * from "./service_safety.vue?vue&type=script&lang=js&"
import style0 from "./service_safety.vue?vue&type=style&index=0&id=476f8b89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f8b89",
  null
  
)

export default component.exports